// extracted by mini-css-extract-plugin
export var colorSquare = "_tk-0";
export var danger = "_tk-5";
export var lightPink = "_tk-8";
export var neutralBlue = "_tk-7";
export var neutralYellow = "_tk-6";
export var normal = "_tk-1";
export var primary = "_tk-2";
export var primaryLight = "_tk-3";
export var solidBlack = "_tk-g";
export var solidGreen = "_tk-b";
export var solidLightBlue = "_tk-d";
export var solidNavy = "_tk-c";
export var solidOrange = "_tk-f";
export var solidPink = "_tk-e";
export var solidRed = "_tk-9";
export var solidYellow = "_tk-a";
export var success = "_tk-4";